import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NewsLettersLanding from 'Webapp/shared/app/views/newsletters-landing';
import { paramSelector } from 'Webapp/shared/app/redux/selectors/routing';
import {
  usageTrackEnterNewsletterLandingPage,
  usageTrackNewsletterLandingPageSubmitClick,
  usageTrackNewsletterLandingPageSubmission,
} from 'Webapp/shared/app/redux/actions/usage-actions';

const mapStateToProps = (state) => {
  const key = paramSelector(state).key;

  return {
    configuration: state.newsLettersLanding.configuration[key],
    keyProperty: key,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      usageTrackEnterNewsletterLandingPage,
      usageTrackNewsletterLandingPageSubmitClick,
      usageTrackNewsletterLandingPageSubmission,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(NewsLettersLanding);
